export default "__VITE_ASSET__9a6b1186__"